module.exports = __webpack_public_path__ + "static/img/10.5a46433.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/10.png
// module id = 1Trn
// module chunks = 0